import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import InfoTooltip from './icons/info-small';

export const withTooltips = (BaseComponent, tooltips) => {
    class WithTooltips extends React.Component {
        constructor(props) {
            super(props);
            const decoratedOptions = props.options.map((option, idx) => {
                option.tooltip = tooltips[idx];
                return option;
            });

            this.state = {
                options: decoratedOptions
            };
        }

        renderTooltip(option, idx) {
            return (
                <OverlayTrigger
                    placement="right"
                    overlay={
                        <Tooltip id={`${this.name}-tooltip-${idx}`}>
                            {/* Unused component */}
                            <span>
                                {option.tooltip}
                            </span>
                        </Tooltip>
                    }
                >
                    <span>
                        <InfoTooltip />
                    </span>
                </OverlayTrigger>
            );
        }

        render() {
            return (
                <BaseComponent
                    options={this.state.options}
                    renderTooltip={this.renderTooltip}
                    {...this.props}
                />
            );
        }
    }

    WithTooltips.displayName = `WithTooltips(${getDisplayName(BaseComponent)})`;

    return WithTooltips;
};

const getDisplayName = BaseComponent =>
    BaseComponent.displayName || BaseComponent.name || 'Component';

export default withTooltips;
